import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import I18n from 'I18n';
import UIButton from 'UIComponents/button/UIButton';
import UISelect from 'UIComponents/input/UISelect';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import Small from 'UIComponents/elements/Small'; // @ts-expect-error could not find declaration

import KnowledgeBaseLink from 'AdsUI/components/KnowledgeBaseLink';
import NetworkSelectOption from 'AdsUI/components/NetworkSelectOption';
import NetworkSelectValue from 'AdsUI/components/NetworkSelectValue'; // @ts-expect-error could not find declaration

import { KBArticles } from 'AdsUI/lib/Constants'; // @ts-expect-error could not find declaration

import NetworkIcon from 'ads-account-connection/components/NetworkIcon';
// @ts-expect-error could not find declaration
import { Networks } from 'AdsUI/lib/Constants'; // @ts-expect-error importing from JS file

import { getPixels } from 'AdsUI/selectors/AudiencesSelectors';

/**
 * Get text used to describe a pixel.
 * @param pixel
 * @returns A string with the pixel's name (if it exists), network, and ID
 */
const getPixelText = pixel => {
  const name = pixel.name ? `${pixel.name} - ` : '';
  return `${name}${I18n.text(pixel.adNetwork.toLowerCase())} (${pixel.id})`;
};

const PixelSelect = ({
  showErrors,
  selectedPixel,
  addPixel,
  facebookBusinessExtensionAuth,
  selectedAdAccount,
  handleSelectPixel
}) => {
  const allPixels = useSelector(getPixels);
  const pixelRecords = allPixels.filter(pixel => {
    return pixel.accountId === selectedAdAccount.accountId && pixel.adNetwork === selectedAdAccount.network && pixel.installed === true;
  });
  const pixels = pixelRecords.toJS();
  const facebookExtensionInstalled = selectedPixel && selectedPixel.adNetwork === Networks.FACEBOOK && (selectedPixel.fbeinstalled || facebookBusinessExtensionAuth && facebookBusinessExtensionAuth.userToken);

  const renderContent = () => {
    if (selectedPixel) {
      return /*#__PURE__*/_jsx(UISelect, {
        "data-test-id": "event-pixel-select",
        onChange: e => handleSelectPixel(pixelRecords.find(pixelRecord => pixelRecord.id === e.target.value)),
        options: pixels.map(pixel => ({
          text: getPixelText(pixel),
          networkIcon: /*#__PURE__*/_jsx(NetworkIcon, {
            network: pixel.adNetwork,
            size: 20
          }),
          value: pixel.id
        })),
        optionComponent: NetworkSelectOption,
        value: selectedPixel && selectedPixel.id,
        valueComponent: NetworkSelectValue
      });
    }

    return /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary",
      size: "small",
      onClick: addPixel,
      className: "install-pixel-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "audiences.wizard.website.generic.addPixelButton"
      })
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-3",
    children: [/*#__PURE__*/_jsx(UIHelpIcon, {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "events.creation.CRM_EVENT.formSubmission.pixel.tooltip.paragraph1_jsx",
            elements: {
              KnowledgeBaseLink
            },
            options: {
              kbArticle: KBArticles.INSTALL_PIXELS_EXTERNAL_NETWORK,
              context: 'form-submission-pixel-select'
            }
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "events.creation.CRM_EVENT.formSubmission.pixel.tooltip.paragraph2"
          })
        })]
      }),
      children: /*#__PURE__*/_jsx(UIFormLabel, {
        className: "p-all-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "events.creation.CRM_EVENT.formSubmission.pixel.label"
        })
      })
    }), !selectedPixel && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        weight: "medium",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "events.creation.CRM_EVENT.formSubmission.pixel.help"
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-top-1 m-bottom-1",
      children: renderContent()
    }), /*#__PURE__*/_jsx(KnowledgeBaseLink, {
      kbArticle: KBArticles.SYNC_FB_FORM_SUBMISSION_EVENTS,
      context: "sync-facebook-form-ads-converstion-events",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "events.info.pixel.learnMore"
      })
    }), showErrors && !selectedPixel && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        use: "error",
        weight: "medium",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "events.creation.CRM_EVENT.errors.pixelRequired"
        })
      })
    }), showErrors && selectedPixel && selectedPixel.adNetwork === Networks.FACEBOOK && !facebookExtensionInstalled && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        use: "error",
        weight: "medium",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "events.creation.CRM_EVENT.errors.facebookAuthRequired"
        })
      })
    })]
  });
};

export default PixelSelect;